import {createSelector} from 'reselect';

import ModalTypes from '../../enums/app/modalTypes';
import {IRootState} from '../state';
import {IModal} from '../types/modal';

const selectModal = (state: IRootState) => state.modal;

const selectGlobalModals = createSelector(selectModal, (modalState) => modalState.globalModals);
const selectRenderedModals = createSelector(selectModal, (modalState) => modalState.renderedModals);

const makeSelectVisibleGlobalModal = createSelector(
    selectGlobalModals,
    (state: IModal[], modalType: ModalTypes) => modalType,
    (modalState, modalType) => modalState.some((modal) => modal.modalType === modalType)
);

const makeSelectGlobalModal = (modalType: ModalTypes): any =>
    createSelector(selectGlobalModals, (modalState) => modalState.find((modal) => modal.modalType === modalType));

const makeSelectIsVisibleRenderedModal = (id: string): any =>
    createSelector(selectRenderedModals, (modals) => {
        const lastModalId = modals.length ? modals[modals.length - 1] : null;

        return lastModalId === id;
    });

export {makeSelectGlobalModal, makeSelectIsVisibleRenderedModal, makeSelectVisibleGlobalModal, selectGlobalModals};
